import { render, staticRenderFns } from "./Rollen.vue?vue&type=template&id=355c6f02&"
import script from "./Rollen.vue?vue&type=script&lang=js&"
export * from "./Rollen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports